<template>
  <div class="yuliPrizeBlock">
    <!-- 角色卡片背景 -->
    <div class="card">
      <img
        :src="
          require(`@/assets/images/YuliApp/storageActivity/storageUpgrade/roleBg/${role_property}_card@2x.png`)
        "
      />
    </div>

    <!-- 角色图片 -->
    <div class="role">
      <img
        :src="`https://yf.yuliverse.com/${
          ENV === 'development' ? 'dev' : ENV === 'beta' ? 'beta' : 'prod'
        }/md/images/${number}.png`"
      />
    </div>

    <!-- 内容 -->
    <div
      class="block"
      :style="{
        backgroundImage: `url(${require(`@/assets/images/YuliApp/storageActivity/storageUpgrade/roleBg/${role_property}@2x.png`)})`,
      }"
    >
      <!-- 编号、品质、属性 -->
      <div class="block-header">
        <p class="block-header-number">
          NO.{{
            number.toString().length > 7
              ? number.toString().slice(0, 3) +
                "..." +
                number.toString().slice(-4)
              : number
          }}
        </p>
        <div class="block-header-image">
          <img :src="role_pz_image" />
          <img :src="role_sx_image" />
        </div>
      </div>

      <div class="block-content">
        <div class="block-content-top">
          <!-- 奖励 -->
          <div class="reward">
            <div class="reward-arg">
              <img
                :src="
                  require('@/assets/images/YuliApp/storageActivity/icon_arg.png')
                "
              />
              <p class="reward-arg-number">{{ arg_number }}</p>
            </div>
            <!-- <div class="reward-ticket">
              <p class="reward-ticket-number">{{ ticket_number }}</p>
            </div> -->
          </div>
          <div class="timebox">
            <!-- 文案 -->
            <p class="timebox-text">Yuli Character Achieve Lv.30</p>

            <!-- 提取按钮 -->
            <div
              class="timebox-button"
              :class="[
                is_draw
                  ? 'claimed'
                  : purify_count >= total_goal_count
                  ? 'canDraw'
                  : 'inProgress',
              ]"
              @click="drawPrize(arg_number, ticket_number)"
            >
              <div class="timebox-button-btnText">
                {{ is_draw ? "" : "Claim" }}
              </div>
              <p class="timebox-button-time" v-if="is_draw">
                {{ claimed_time }}
              </p>
            </div>
          </div>
        </div>
        <div class="block-content-progress">
          <!-- 进度条 -->
          <div class="block-content-progress-detail">
            <div
              class="block-content-progress-detail-line"
              :style="{ width: divWidth }"
            ></div>
            <div class="block-content-progress-detail-level">
              {{
                `${purify_count > 30 ? 30 : purify_count}/${total_goal_count}`
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed } from "vue";
import { postSprintSaving } from "@/api/activity.js";
import _ from "lodash";
const { NODE_ENV } = process.env;
export default {
  props: {
    arg_number: {
      type: String,
      default: "",
    },
    ticket_number: {
      type: String,
      default: "",
    },
    role_sx_image: {
      type: String,
      default: "",
    },
    role_pz_image: {
      type: String,
      default: "",
    },
    role_property: {
      type: String,
      default: "common",
    },
    purify_count: {
      type: Number,
      default: 0,
    },
    total_goal_count: {
      type: Number,
      default: 0,
    },
    number: {
      type: Number,
      default: 0,
    },
    isDraw: {
      type: Boolean,
      default: false,
    },
    claimed_time: {
      type: String,
      default: "",
    },
  },

  watch: {
    purify_count: {
      handler(value) {
        //收集进度
        if (value >= this.total_goal_count) {
          this.divWidth = "100%";
        } else {
          this.divWidth =
            ((value * 120) / this.total_goal_count).toFixed(2) + "px";
        }
      },
      immediate: true,
      deep: true,
    },
    isDraw: {
      handler(value) {
        this.is_draw = value;
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const { number, purify_count, role_property } = props;

    const divWidth = ref("");
    const totalCount = ref("");
    const purifyCount = ref("");
    const is_draw = ref(false);
    const token_id = ref("");
    const ENV = ref(NODE_ENV);

    token_id.value = number;
    // is_draw.value = isDraw;

    onMounted(() => {});

    const drawPrize = (arg_number, ticket_number) => {
      if (is_draw.value) {
        return;
      }
      postSprintSaving({ token_id: token_id.value })
        .then((res) => {
          const code = _.get(res.data, "code", 0);
          if (code === 200404) {
            emit("drawError", token_id.value);
            return;
          }
          // is_draw.value = true;
          emit("drawArg", arg_number, ticket_number);
        })
        .catch((error) => {});
    };
    return {
      divWidth,
      drawPrize,
      is_draw,
      totalCount,
      purifyCount,
      ENV,
    };
  },
};
</script>
>
<style lang="less" scoped>
p {
  margin: 0;
  padding: 0;
}
.yuliPrizeBlock {
  position: relative;
  width: 359px;
  height: 201px;
  margin: 0 auto;
  margin-bottom: 10px;
}
.card {
  position: absolute;
  z-index: 9;
  top: 0;
  left: 0;
  width: 156px;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
.role {
  height: 100%;
  width: 156px;
  position: absolute;
  z-index: 10;
  img {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 128px;
    height: 128px;
  }
}

.block {
  position: absolute;
  z-index: 11;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;

  display: flex;
  // justify-content: space-between;

  &-header {
    position: relative;
    box-sizing: border-box;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 156px;

    &-number {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 43.75px;
      opacity: 0.6000000238418579;
      color: rgba(255, 255, 255, 1);
      font-size: 11px;
      font-weight: 700;
      font-family: "PingFang SC";
      text-align: center;
      line-height: 13.2px;
    }
    &-image {
      width: 58px;
      position: absolute;
      left: 50.7%;
      transform: translate(-50%, 0);
      bottom: 14.35px;
      display: flex;
      justify-content: space-between;
      img {
        width: 24px;
        height: 24px;
        // margin-right: 10px;
      }
    }
  }

  &-content {
    flex-shrink: 0;
    position: relative;
    left: -18px;
    width: 221px;
    box-sizing: border-box;
    padding-top: 55px;
    &-top {
      display: flex;
      justify-content: center;
      align-items: center;
      .reward {
        margin-right: 10px;
        &-arg,
        &-ticket {
          position: relative;
          // width: 48px;
          // height: 48px;
          width: 59px;
          height: 79px;
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/icon_bg@2x.png");
          background-size: 100% 100%;
          text-align: center;
          img {
            position: absolute;
            left: 50%;
            top: 30.51px;
            transform: translate(-50%, -50%);
            // width: 38px;
            // height: 38px;
            width: 49px;
            height: 49px;
          }
          &-number {
            height: 15.6px;
            position: absolute;
            bottom: 1px;
            left: 50%;
            transform: translate(-50%, 0);
            color: #1f263e;
            font-size: 11px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: center;
            line-height: 13.6px;
          }
        }
        &-ticket {
          margin-top: 4px;
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/reward_ticket@2x.png");
        }
      }

      .timebox {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 101px;
        &-text {
          width: 100%;
          opacity: 0.9;
          color: rgba(2, 5, 24, 1);
          font-size: 14px;
          font-weight: 700;
          font-family: "PingFang SC";
          text-align: center;
          line-height: 18px;
          margin-bottom: 10px;
        }

        &-button {
          box-sizing: border-box;
          width: 88px;
          height: 30px;
          background-size: 100% 100%;
          line-height: 30px;
          font-family: "PingFang HK";
          &-btnText {
            font-size: 15px;
            font-weight: 500;
            text-align: center;
          }
          &-time {
            padding-left: 21px;
            color: rgba(180, 212, 219, 1);
            font-size: 12px;
            font-weight: 400;
            text-align: left;
            letter-spacing: -0.22px;
            transform: scale(0.8);
          }
        }
        .inProgress {
          color: rgba(223, 223, 210, 1);
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/btn_inProgress@2x.png");
        }
        .canDraw {
          color: rgba(254, 255, 217, 1);
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/btn_canClaim@2x.png");
        }
        .claimed {
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/btn_claimed@2x.png");
        }
      }
    }

    &-progress {
      display: flex;
      justify-content: center;
      margin-left: -7px;

      &-detail {
        position: relative;
        margin-top: 17px;
        width: 120px;
        height: 15px;
        border-radius: 2px;
        background: rgba(134, 173, 230, 0.5);
        &-line {
          width: 0;
          height: 15px;
          border-radius: 2px;
          background: #228c87;
        }
        &-level {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: rgba(255, 255, 255, 1);
          font-size: 11px;
          font-weight: 500;
          font-family: "PingFang SC";
          text-align: center;
          line-height: 13.2px;
          letter-spacing: 0.71px;
          opacity: 0.9;

          // text-stroke: 1px #020518;
          // /* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
          // -webkit-text-stroke: 0.5px #020518;
        }
      }
    }
  }
}
.default {
  background-image: url("~@/assets/images/YuliApp/storageActivity/default.png");
  background-size: 100% 100%;

  position: relative;
  box-sizing: border-box;
  width: 340px;
  height: 164px;
  margin: 0 auto;
  margin-bottom: 60px;
  padding: 15px 18px 0 16px;
}
</style>
